export var LevelName;
(function (LevelName) {
    LevelName["basic"] = "basic";
    LevelName["extended"] = "extended";
    LevelName["advanced"] = "advanced";
})(LevelName || (LevelName = {}));
